import type { MessageKey, Translate } from '../i18n';

/**
 * ┌───────────────────────────────────────────────────────────────────────────┐
 * │ A feature flag's name, as a person reads it.                              │
 * └───────────────────────────────────────────────────────────────────────────┘
 *
 * ⚠️ **The registry carries a developer's description in English and no name** — `packages/shared`
 * is string-agnostic under rule 7. The redesign prints *MCP-hozzáférés* over `mcp.access`, so the
 * console names each registered key here, in its own catalogue.
 *
 * ⚠️ **One literal `t()` per branch** — `i18n:check` reads literal arguments only. An unregistered
 * key falls back to the key itself, mono, which is what the row prints underneath anyway: a newer
 * API with a flag this build does not know shows its key rather than a blank.
 */
export function featureName(key: string, t: Translate): string {
  switch (key) {
    case 'reports.view':
      return t('feature.reports');
    case 'contracts.line_item_pricing':
      return t('feature.lineItemPricing');
    case 'contracts.work_free_revenue':
      return t('feature.workFreeRevenue');
    case 'agent.chat':
      return t('feature.agent');
    case 'mcp.access':
      return t('feature.mcp');
    default:
      return key;
  }
}

export type FeatureNameKey = Extract<MessageKey, `feature.${string}`>;
